<template>
  <Navbar :placement="placement" type="default" :fluid="true">
    <a slot="brand" :href="LANDING_URL" class="navbar-brand">
      <img alt="Vestbee" src="/static/img/logo-dark-home.jpg" width="105" />
    </a>
    <ul slot="right" class="nav navbar-nav navbar-right">
      <li v-show="isAuthorized">
        <router-link :to="dashboardRoute">
          Dashboard
        </router-link>
      </li>
      <li v-show="isAuthorized">
        <a href @click.prevent="logout()">Logout</a>
      </li>
      <li v-show="!isAuthorized">
        <router-link :to="{ name: 'login' }">
          Login
        </router-link>
      </li>
      <li v-show="false">
        <a href @click.prevent="openSignupModal()">Sign up</a>
        <SignupModal
          v-show="!signupModalVisible"
          :show="signupModalVisible"
          @close="closeSignupModel()"
        />
      </li>
    </ul>
  </Navbar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import SignupModal from './components/SignupModal.vue'
import Navbar from './vue-strap/Navbar.vue'
import GlobalSettings from 'GlobalSettings'

export default {
  props: {
    placement: {
      type: String,
      default: 'static',
    },
  },
  data: () => ({
    loginModalVisible: false,
    signupModalVisible: false,
  }),
  computed: {
    LANDING_URL: () => GlobalSettings.LANDING_URL,
    ...mapState({
      isAuthorized: (state) => state.user.isAuthorized,
    }),
    ...mapGetters({
      dashboardRoute: 'user/dashboardRoute',
    }),
  },
  components: {
    SignupModal,
    Navbar,
  },
  methods: {
    openLoginModal() {
      this.loginModalVisible = true
    },
    closeLoginModel() {
      this.loginModalVisible = false
    },
    openSignupModal() {
      this.signupModalVisible = true
    },
    closeSignupModel() {
      this.signupModalVisible = false
    },
    logout() {
      this.$store.dispatch('user/logout')
    },
  },
}
</script>
